// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateSelectedValue = selectedValue => ({
    selectedValue,
    type: actions.UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_VALUE
});



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/action-creators/selected-value.js